import React from "react";
import { Container, CssBaseline } from "@mui/material"

function Map () {
    return (
        <>
        <CssBaseline />
        <Container id="targetElementId" style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '100%',
          padding: '0',
      }}>

          <iframe title="Mapa" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d229.48128783250309!2d-49.16590683954321!3d-23.034762612508008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c0e3c205a4d707%3A0x935862d1e9e98525!2sAcademia%20Billy%20Gym!5e0!3m2!1spt-BR!2sbr!4v1704381680627!5m2!1spt-BR!2sbr"
              width="100%"
              height="350"
              style={{ border: "0" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade">
          </iframe>
      </Container>
        </>
    );
};
export default Map;